import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from "@material-ui/core/styles/withStyles";
import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

// 기타 react
import { FormattedMessage } from 'react-intl';
import { NavLink } from "react-router-dom";
import cx from "classnames";

// @material-ui/core components
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from "@material-ui/core/Icon";
import Divider from '@material-ui/core/Divider';

// @material-ui/icons components
import FolderOpen from '@material-ui/icons/FolderOpen';
import FolderClose from '@material-ui/icons/Folder';

// custom
import Badge from 'components/react-custom-template/Badge/Badge';
import SidebarIcons from './SidebarIcons';
import { 
    SIDEBAR_TYPE_DIVIDER,
    SIDEBAR_TYPE_COLLAPSE,
    BADGE_MAX_NO
} from 'util/constants';


/**
 * material-dashboard-pro-react-v1.5.0 > Sidebar.jsx 참고
 */
class SidebarMenus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //openedSidebarIds: [],// 하위메뉴가 열려있는 사이드바의 id 정보
            ...this.getCollapseStates(props.sidebarItems)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) { //componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.
        if( nextProps.sidebarItems !== this.props.sidebarItems ) {
            this.setState({ ...this.getCollapseStates(nextProps.sidebarItems) });
        }
    };

    // 리렌더링이 불필요한 케이스 정의 
    shouldComponentUpdate(nextProps, nextState){
        if (
            nextProps.sidebarItems === this.props.sidebarItems &&
            nextProps.isSidebarOpen === this.props.isSidebarOpen &&
            nextProps.matchUrl === this.props.matchUrl &&
            nextState === this.state
        ) {
            console.log("SidebarMenus >> shouldComponentUpdate : false");
            return false;
        }
        console.log("SidebarMenus >> shouldComponentUpdate : true");
        return true;
    }

    // 주소를 기준으로 해당 메뉴가 열려있어야 하는지 확인
    getCollapseInitialState(items) {
        for (let idx = 0; idx < items.size; idx++) {
            const item = items.get(idx);
            if (item.type === SIDEBAR_TYPE_COLLAPSE && this.getCollapseInitialState(item.children)) {
                return true;
            } else if (window.location.href.indexOf(item.path) !== -1) {
                return true;
            }
        }
        return false;
    }

    // 기본으로 열려있어야 하는 메뉴 확인 (ex. 하위메뉴에서 새로고침 시 상위메뉴가 열려져있어야 함)
    getCollapseStates = items => {
        let initialState = {};
        items.map((prop, key) => {
            if (prop.type === SIDEBAR_TYPE_COLLAPSE) {
                initialState = {
                    //[prop.id]: this.getCollapseInitialState(prop.children),
                    [prop.id]: this.state && this.state[prop.id] ? this.state[prop.id] : this.getCollapseInitialState(prop.children),
                    ...this.getCollapseStates(prop.children),
                    ...initialState
                };
            }
            return null;
        });
        return initialState;
    };

    openCollapse = (collapse) => (event) => {
        event.preventDefault();
        var st = {};
        st[collapse] = !this.state[collapse];
        this.setState(st);
    }

    createLinks = (sidebarItems, isCollapse) => {
        const { classes, color, badgeColor, isSidebarOpen } = this.props;
        
        return sidebarItems.map( (sidebarItem, key) => {
            // 구분선인 경우 
            if( sidebarItem.type === SIDEBAR_TYPE_DIVIDER ) {
                return <Divider key={`${SIDEBAR_TYPE_DIVIDER}_${key}`} />; 
            // title인 경우 (하위메뉴가 있는 경우 열고 닫는 이벤트도 적용)
            } else if( sidebarItem.type === SIDEBAR_TYPE_COLLAPSE ) {
                var st = {};
                st[sidebarItem.id] = !this.state[sidebarItem.id];

                const navLinkClasses =
                    classes.itemLink +
                    " " +
                    cx({
                        // [" " + classes.collapseActive]: openedSidebarIds.indexOf(sidebarItem.id) > -1
                        // [" " + classes.collapseActive]: this.getCollapseInitialState(sidebarItem.id)
                        [" " + classes.collapseActive]: this.state[sidebarItem.id]
                    });

                const itemText =
                    classes.itemText +
                    " " +
                    cx({
                        [classes.itemTextMini]: !isSidebarOpen,
                    });

                const SidebarIconComponent = sidebarItem.iconType ? SidebarIcons[sidebarItem.iconType] : null;

                return (
                    <ListItem 
                        key={sidebarItem.id} 
                        className={classes.item}
                    >
                        <NavLink
                            to={"#"}
                            className={navLinkClasses}
                            onClick={this.openCollapse(sidebarItem.id)}
                        >
                            {SidebarIconComponent ? (
                                <SidebarIconComponent className={classes.itemIcon} />
                            ) : (
                                sidebarItem.children && this.state[sidebarItem.id] ? 
                                    <FolderOpen className={classes.itemIcon} /> : <FolderClose className={classes.itemIcon} />
                            )}
                            <ListItemText
                                primary={ sidebarItem.sidebarName ?
                                    <FormattedMessage id={sidebarItem.sidebarName} /> : sidebarItem.name
                                }
                                secondary={
                                    <b
                                        className={
                                            classes.caret +
                                            " " +
                                            (this.state[sidebarItem.id] ? classes.caretActive : "")
                                        }
                                    />
                                }
                                disableTypography={true}
                                className={itemText}
                            />
                        </NavLink>
                        <Collapse in={this.state[sidebarItem.id]} unmountOnExit>
                            <List className={classes.list + " " + classes.collapseList}>
                                {this.createLinks(sidebarItem.children, true)}
                            </List>
                        </Collapse>
                    </ListItem>
                );
            }

            // 일반 메뉴
            const itemText =
                classes.itemText +
                " " +
                cx({
                    [classes.itemTextMini]: !isSidebarOpen,
                });

            const collapseItemText =
                classes.collapseItemText +
                " " +
                cx({
                    [classes.collapseItemTextMini]: !isSidebarOpen,
                });

            const sidebarNameClassName = cx({
                "folderNameOverflow": isSidebarOpen,
                "folderNameOverflowMini": !isSidebarOpen
            });
            const badgeClassName = cx({
                "folderBadge": isCollapse,
            });
    
            const navLinkProps = sidebarItem && sidebarItem.hash ? {
                to: sidebarItem.hash,
            } : {
                to: sidebarItem.path ? sidebarItem.path : "#",
                activeClassName: classes[color],
            }
            const SidebarIconComponent = sidebarItem.iconType ? SidebarIcons[sidebarItem.iconType] : null;

            return (
                <ListItem
                  key={sidebarItem.id}
                  className={cx(
                    { [classes.bottom]: sidebarItem.isBottomMenu },
                    { [classes.item]: !isCollapse },
                    { [classes.collapseItem]: isCollapse }
                  )}
                >

                    <NavLink
                        className={cx(
                            { [classes.itemLink]: !isCollapse },
                            { [classes.collapseItemLink]: isCollapse }
                        )}
                        {...navLinkProps}
                    >
                        {sidebarItem.iconType !== undefined ? (
                            <SidebarIconComponent className={classes.itemIcon} />
                        
                        ) : isCollapse ? (
                            <span className={classes.collapseItemMini}>
                                {sidebarItem.name.charAt(0)}
                            </span>
                        ) : (
                            <Icon className={classes.itemIcon}>{sidebarItem.name.charAt(0)}</Icon>
                        )}
                        { !isSidebarOpen && sidebarItem.badgeCnt > 0 
                            && (<span className={classes.notifications + ` sidebarMenuNotification-${badgeColor}`}>
                                    {sidebarItem.badgeCnt > BADGE_MAX_NO ? `${BADGE_MAX_NO}+` : sidebarItem.badgeCnt}
                                </span>)
                        }
                        <ListItemText
                            primary={ sidebarItem.sidebarName ?
                                <FormattedMessage id={sidebarItem.sidebarName} /> : <span className={sidebarNameClassName}>{sidebarItem.name}</span> }
                            secondary={ sidebarItem.badgeCnt > 0 
                                && <Badge color={badgeColor} className={badgeClassName}>{sidebarItem.badgeCnt > BADGE_MAX_NO ? `${BADGE_MAX_NO}+` : sidebarItem.badgeCnt}</Badge> }
                            disableTypography={true}
                            className={cx( "sidebarNameOverflow",
                                { [itemText]: !isCollapse },
                                { [collapseItemText]: isCollapse }
                            )}
                        />
                    </NavLink>
                </ListItem>
            );
        });
    };

    render() {
        console.log("SidebarMenus > render");
        const {
            classes,
            sidebarItems,
            isSmallScreen
        } = this.props;

        return (
            <List className={cx({
                [classes.list]: true,
                "sidebarHeight": !isSmallScreen,
                "smailSidebarList": isSmallScreen,
                "smailSidebarCompanyAdmin": false
            })}>
                {this.createLinks(sidebarItems, false)}
            </List>
        );
    }
}

SidebarMenus.propTypes = {
    classes: PropTypes.object.isRequired,
    badgeColor: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    isSidebarOpen: PropTypes.bool.isRequired,
    matchUrl: PropTypes.string.isRequired,
    sidebarItems: PropTypes.array.isRequired
};

const SidebarMenusWithStyles = withStyles(sidebarStyle)(SidebarMenus);

export default SidebarMenusWithStyles;
